/* ============================================================
   LiquorVerse Matchmaker (matchmaker-v3).
   ==================== BRAIN SEAM (§10) ======================
   When the Brain ships, set the section's "Brain endpoint" —
   POST {endpoint}  body {bottle: "..."}
   response {note, matches:[{title, url, meta, match_pct,
     price_cents, stock: 'in'|'low'|'out', variant_id, image,
     shared:[...], why}]}
   Until then the STUB fetches the fallback collection's products
   (price/stock LIVE from the store) and renders them as matches
   with flavor-tag chips. API key never touches the theme (§2.3).
   Out-of-stock notify joins the same restock list the Your Verse
   dashboard reads — Klaviyo back-in-stock seam noted (§7).
   ============================================================ */
(function () {
  'use strict';

  var RESTOCK_KEY = 'lv_restock';

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function money(cents) {
    return window.LV ? window.LV.fmtUSD(cents) : '$' + Math.round(cents / 100);
  }

  function init(root) {
    var endpoint = root.dataset.brainEndpoint || '';
    var fallbackCollection = root.dataset.fallbackCollection || '';
    var input = root.querySelector('[data-lv-mm-input]');
    var btn = root.querySelector('[data-lv-mm-btn]');
    var loading = root.querySelector('[data-lv-mm-loading]');
    var results = root.querySelector('[data-lv-mm-results]');
    var grid = root.querySelector('[data-lv-mm-grid]');
    var loved = root.querySelector('[data-lv-mm-loved]');
    var note = root.querySelector('[data-lv-mm-note]');
    var err = root.querySelector('[data-lv-mm-err]');
    if (!input || !btn || !grid) return;

    function stubWhy(bottle, title) {
      return 'Shares the backbone of ' + bottle + ' — pulled from the shelf our team reaches for when that bottle is gone. (Demo match — the Brain brings the real reasoning.)';
    }

    /* ---- STUB: fallback collection products as matches ---- */
    function stubMatch(bottle) {
      if (!fallbackCollection) return Promise.reject(new Error('no fallback'));
      return fetch('/collections/' + fallbackCollection + '/products.json?limit=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.products || []).filter(function (p) {
            return p.title.toLowerCase().indexOf(bottle.toLowerCase()) === -1; /* don't match the bottle itself */
          }).slice(0, 3);
          return {
            note: 'Demo matches from our shelf — live price & stock. The Matchmaker brain comes online soon.',
            matches: products.map(function (p, i) {
              var v = p.variants && p.variants[0];
              var flavorTags = (p.tags || []).filter(function (t) { return t.indexOf('flavor:') === 0; })
                .map(function (t) { return t.replace('flavor:', '').replace(/-/g, ' '); }).slice(0, 4);
              return {
                title: p.title,
                url: '/products/' + p.handle,
                meta: p.product_type || '',
                match_pct: 93 - i * 6,
                price_cents: v ? Math.round(parseFloat(v.price) * 100) : 0,
                stock: p.available ? 'in' : 'out',
                variant_id: v ? v.id : null,
                image: p.images && p.images[0] ? p.images[0].src : null,
                shared: flavorTags,
                why: stubWhy(bottle, p.title)
              };
            })
          };
        });
    }

    function brainMatch(bottle) {
      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bottle: bottle })
      }).then(function (r) {
        if (!r.ok) throw new Error('brain error');
        return r.json();
      });
    }

    function card(m) {
      var stockLabel = m.stock === 'in' ? 'In stock' : m.stock === 'low' ? 'Almost gone' : 'Out of stock';
      var html = '<article class="lv-m-card">' +
        '<div class="lv-m-top">' +
        '<div class="lv-m-pct">' + Math.round(m.match_pct) + '%<small>Match</small></div>' +
        (m.image ? '<img src="' + esc(m.image) + '" alt="" loading="lazy">' : '<div class="lv-m-bottle" aria-hidden="true"></div>') +
        '</div><div class="lv-m-body">' +
        '<h3><a href="' + esc(m.url) + '">' + esc(m.title) + '</a></h3>' +
        (m.meta ? '<div class="lv-m-meta">' + esc(m.meta) + '</div>' : '') +
        (m.shared && m.shared.length ? '<div class="lv-m-chips">' + m.shared.map(function (c) { return '<span class="lv-m-chip">' + esc(c) + '</span>'; }).join('') + '</div>' : '') +
        (m.why ? '<div class="lv-m-why">&ldquo;' + esc(m.why) + '&rdquo;</div>' : '') +
        '<span class="lv-m-stock ' + m.stock + '">' + stockLabel + '</span>';
      if (m.stock === 'out') {
        html += '<div class="lv-m-notify-form" data-handle="' + esc(m.url.split('/').pop()) + '">' +
          '<input type="email" placeholder="you@email.com" aria-label="Email for restock alert">' +
          '<button type="button" data-lv-mm-notify>Notify me</button></div>';
      } else {
        html += '<div class="lv-m-row"><span class="lv-m-price">' + money(m.price_cents) + '</span>' +
          (m.variant_id ? '<button class="lv-m-add" type="button" data-lv-add-id="' + esc(m.variant_id) + '">Add to cart</button>' : '') +
          '</div>';
      }
      html += '</div></article>';
      return html;
    }

    var busy = false;
    function go(bottle) {
      bottle = (bottle || input.value).trim();
      if (!bottle || busy) return;
      busy = true;
      btn.disabled = true;
      if (err) err.classList.remove('show');
      if (results) results.classList.remove('show');
      if (loading) loading.classList.add('show');

      var matcher = endpoint ? brainMatch(bottle) : stubMatch(bottle);
      matcher.then(function (data) {
        if (loved) loved.textContent = bottle;
        if (note) note.textContent = data.note || '';
        grid.innerHTML = (data.matches || []).map(card).join('');
        if (results) results.classList.add('show');
        results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }).catch(function () {
        if (err) {
          err.textContent = "The Matchmaker is off nosing new bottles — try again in a bit, or browse the verses instead.";
          err.classList.add('show');
        }
      }).finally(function () {
        busy = false;
        btn.disabled = false;
        if (loading) loading.classList.remove('show');
      });
    }

    btn.addEventListener('click', function () { go(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') go(); });
    root.querySelectorAll('[data-lv-mm-try]').forEach(function (t) {
      t.addEventListener('click', function () {
        input.value = t.dataset.lvMmTry;
        go();
      });
    });

    /* restock notify → shared lv_restock list (Your Verse reads it).
       KLAVIYO SEAM: becomes a back-in-stock subscription (§7). */
    grid.addEventListener('click', function (e) {
      var nb = e.target.closest('[data-lv-mm-notify]');
      if (!nb) return;
      var form = nb.closest('.lv-m-notify-form');
      var email = form.querySelector('input').value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
      var handle = form.dataset.handle;
      try {
        var list = JSON.parse(localStorage.getItem(RESTOCK_KEY)) || [];
        if (list.indexOf(handle) === -1) list.push(handle);
        localStorage.setItem(RESTOCK_KEY, JSON.stringify(list));
      } catch (err2) { /* private mode */ }
      var done = document.createElement('div');
      done.className = 'lv-m-notify-done';
      done.textContent = "✓ You're on the list — we'll flag it in Your Verse too.";
      form.replaceWith(done);
    });
  }

  function boot() {
    document.querySelectorAll('[data-lv-matchmaker]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
